// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2CEA4","noInteraction":"EventWrapper_noInteraction__Pk5Qg"};